var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 61,
    viewBox: "0 0 1440 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440C1440 0 1423.51 3.82457 1399 9.52613C1363.15 17.8664 1310.14 30.2231 1266.5 40.5C1077.65 84.9729 955.392 26.2057 755.663 30.5625C569.914 34.6143 469.911 76.4334 287 54.0417C168.445 39.5285 0 0 0 0Z",
    fill: "#F4F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBottom);
export default __webpack_public_path__ + "static/media/wave_bottom.ebc011867e2617a6845e1430be060893.svg";
export { ForwardRef as ReactComponent };